export type ScopeCenterPoint = {
  lng: number;
  lat: number;
};

export const parseScopeCenterPoint = (
  value: unknown
): ScopeCenterPoint | null => {
  if (typeof value !== "string" || value.trim() === "") {
    return null;
  }

  try {
    const parsed = JSON.parse(value) as
      | { lng?: unknown; lat?: unknown }
      | [unknown, unknown];

    if (Array.isArray(parsed) && parsed.length >= 2) {
      const lng = Number(parsed[0]);
      const lat = Number(parsed[1]);
      return Number.isFinite(lng) && Number.isFinite(lat) ? { lng, lat } : null;
    }

    const lng = Number(parsed.lng);
    const lat = Number(parsed.lat);
    return Number.isFinite(lng) && Number.isFinite(lat) ? { lng, lat } : null;
  } catch (_error) {
    return null;
  }
};
